import propTypes from 'prop-types';
import React from 'react';
import './Badge.css';

const Badge = props => {
	const {
		className = '',
		style = {},
		children,
		type,
		...rest
	} = props;

	const classNameDef = `
		Badge
		Badge__${type}
		${className}
	`

	return (
		<span className={classNameDef}>
			{ children }
		</span>
	)
}

Badge.propTypes = {
	children: propTypes.oneOfType([
		propTypes.node,
		propTypes.arrayOf(propTypes.node)
	]).isRequired,
	type: propTypes.oneOf(['success', 'danger', 'warning', 'info'])

}

Badge.defaultProps = {
	type: 'info'
}

export default Badge;